import { apiHelper } from "./api_helper";

export const SALESET_REGISTER_API_ENDPOINT = 'saleset-register';
export const saleSetRegisterApi = {
    Select: (request) => apiHelper.post(`${SALESET_REGISTER_API_ENDPOINT}/select`, request),
    SelectHinhThucNopPhi: (request) => apiHelper.post(`${SALESET_REGISTER_API_ENDPOINT}/select-hinhthuc-nopphi`, request),
    Insert: (data) => apiHelper.post(`${SALESET_REGISTER_API_ENDPOINT}`, data),
    InsertMultiple: (data) => apiHelper.post(`saleset-register/insert-multiple`, data),
    Update: (data) => apiHelper.put(`${SALESET_REGISTER_API_ENDPOINT}`, data),
    Delete: (id) => apiHelper.delete(`${SALESET_REGISTER_API_ENDPOINT}/${id}`),
}